import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_password.component.html'
})
export class SetPasswordModalComponent extends BaseSupportModalComponent {
	userId: string;
	password: string;

	async ok() {
		if (confirm(`Вы уверены, что хотите сменить пароль для пользователя ${this.title}?`)) {
			await this.supportService.setPassword(this.userId, this.password, this.spreader.base.comment).toPromise();

			this.execute();
		}
	}
}
